import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12d4a639&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d4a639')) {
      api.createRecord('12d4a639', component.options)
    } else {
      api.reload('12d4a639', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12d4a639&", function () {
      api.rerender('12d4a639', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadExcel/index.vue"
export default component.exports